import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { SystemUserAccount } from "../../../shared/models/system-user-account.model";
import { SigningAgentDesignationAccount } from "../../../shared/models/signing-agent-designation-account.model";
import { SupportUsersTab } from "../../models/support-users-tab";

type FilterableUser = SystemUserAccount | SigningAgentDesignationAccount;

@Component({
    selector: 'app-user-filter',
    templateUrl: "user-filter-form.component.html",
    styleUrls: ['user-filter-form.component.scss'],
    standalone: false
})

export class UserFilterForm implements OnChanges {
  filter = "";

  @Input() userList: FilterableUser[] = [];
  @Input() activeTab: SupportUsersTab = 'client';
  @Output() filteredUserList: EventEmitter<FilterableUser[]> = new EventEmitter<FilterableUser[]>();

  ngOnChanges(changes: any) {
    if (changes.userList) {
      this.performFilter(this.filter, this.userList);
    }
  }

  performFilter(filterBy: string, dataSet: FilterableUser[]): void {
    filterBy = filterBy.toLocaleLowerCase();
    const filteredList = dataSet.filter(user => {
      return Object.values(user).some((property) =>
      String(property).toLocaleLowerCase().includes(filterBy)
      );
    });
    this.filteredUserList.emit(filteredList);
  }
}
